import * as React from "react"
import DateUtils from "../../utils/DateUtils";
import Appointment from "../../model/appointment/Appointment";
import SelectAppointmentStatus from "./SelectAppointmentStatus";
import AppointmentStatus, {AppointmentStatusEnum} from "../../model/appointment/AppointmentStatus";
import {none, Option, option} from "ts-option";
import ConfirmAppointmentStatusChangeModal from "./ConfirmAppointmentStatusChangeModal";
import {getLeadByIdOrRefNo} from "../../store/view/lead";
import Toast from "../helper/Toast";
import User from "../../model/user/User";
import {connect} from "react-redux";
import {RootState} from "../../store/reducer/root/RootState";
import IndividualContact from "../../model/contact/IndividualContact";
import ButtonSecondary from "../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import LeadSmsSentEvent, {LeadAppointmentSmsSentEventData} from "../../model/lead/event/LeadSmsSentEvent";
import {SmsEventSubtypeEnum} from "../../model/lead/event/LeadEvent";
import {isNullOrUndefined} from "util";
import {sendLeadAppointmentSalesEngineerLinkSMS} from "../../store/action/appointment/appointment";
import {Dispatch} from "redux";
import {SalesEngineerApiDto} from "../../api/model/rest";
import {getUser} from "../../store/view/user";
import JobAppointment from "../../model/appointment/job/JobAppointment";
import {getJobByIdOrRefNumber} from "../../store/view/job";
import {getIndividualContact} from "../../store/view/contact";
import {AppointmentTypeEnum} from "../../model/appointment/AppointmentType";
import moment = require("moment");

const classNames = require("classnames");

interface ComponentProps {
	/**
	 * Selected appointment data.
	 */
	appointment: Appointment | JobAppointment;
	/**
	 * Appointment status change callback.
	 * @param {Appointment} appointment
	 */
	onAppointmentStatusChange: (appointment: Appointment) => void;
	/**
	 * Edit appointment action.
	 * @param {Appointment} appointment  .
	 */
	editAppointment: (appointment: Appointment) => void;
	/**
	 * Readonly flag
	 */
	readonly?: boolean;
	/**
	 * On row click callback.
	 */
	onClick: () => void;
	//TODO this should be changed somehow, figure it out after v4 is ready.
	/**
	 * Lead form contact. Needed to show appointment confirmation during lead creation.
	 */
	leadFormContactId: Option<string>;
}

interface DispatchProps {
	/**
	 * Send SMS with profile action.
	 * @param {Appointment} appointment
	 * @param {SalesEngineerApiDto} seData
	 */
	sendLeadAppointmentSalesEngineerLinkSMS: (appointment: Appointment, seData: SalesEngineerApiDto) => void;
}

interface ReduxProps {
	/**
	 * Sales engineer assigned to appointment.
	 */
	salesEngineers: Option<User[]>,
	/**
	 * Appointment lead primary contact.
	 */
	contact: Option<IndividualContact>
	/**
	 * Date of last sent sms.
	 */
	lastSent: Option<moment.Moment>;
}

interface State {
	confirmationVisible: boolean,
	surveyAppointment: boolean;
}

type Props = ComponentProps & ReduxProps & DispatchProps

/**
 * Appointment row presenter.
 */
class AppointmentRow extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			confirmationVisible: false,
			surveyAppointment: props.appointment.type.map(at => at.name === AppointmentTypeEnum.Survey).getOrElse(false)
		};
		this.onChange = this.onChange.bind(this);
		this.sendSms = this.sendSms.bind(this);
	}

	componentWillReceiveProps(nextProps: Props) {
		if (this.props.appointment.type.map(at => at.name !== nextProps.appointment.type.map(nat => nat.name).getOrElse(""))) {
			this.setState({
				surveyAppointment: nextProps.appointment.type.map(at => at.name === AppointmentTypeEnum.Survey).getOrElse(false)
			})
		}
	}

	render() {
		const classes = classNames({
			'disabled': this.props.appointment.dateTime.isBefore(moment())
		});
		const disabledAppointmentStatus = (this.props.appointment instanceof Appointment &&
			(this.props.appointment as Appointment).assigneeId.isEmpty
		);
		return (
			<tr className={classes} onClick={this.props.onClick}>
				<td>{this.props.appointment.dateTime.format(DateUtils.DATE_FORMAT)}</td>
				<td>{this.props.appointment.dateTime.format(DateUtils.TIME_FORMAT)}</td>
				<td>{(moment().isAfter(this.props.appointment.dateTime)) || this.props.readonly ?
					this.props.appointment.status.label :
					<SelectAppointmentStatus
						items={option(AppointmentStatus.getStatusesForAppointmentCreation())}
						selectedId={option(this.props.appointment.status.value)}
						onChanged={this.onChange}
						clearable={false}
						disabled={disabledAppointmentStatus}
					/>}
				</td>
				{this.props.readonly && <td>{`${this.props.appointment instanceof Appointment ? "LEAD" :
					"JOB"}-${this.props.appointment.referenceNumber.orNull}`}</td>}
				{!this.props.readonly &&
				<td>
					<div className={"table-actions"}>
						{moment().isBefore(this.props.appointment.dateTime) &&
						<div className={"action-button"}
							 onClick={() => this.props.appointment instanceof Appointment &&
								 this.props.editAppointment(this.props.appointment)}>
							<img src="../../assets/img/icons/ic-mode-edit-24-px.svg"/>
						</div>}
					</div>
				</td>}
				{this.props.readonly && <td>{this.displayAssignedSalesEngineers()}</td>}
				{this.props.readonly && <td>{this.renderSMSButton()}</td>}
				{this.props.readonly &&
				<td>{this.props.lastSent.map(d => d.format(DateUtils.DATE_TIME_FORMAT)).getOrElse("Not sent yet")}</td>}
				{this.state.confirmationVisible &&
				<ConfirmAppointmentStatusChangeModal onClose={() => this.setState({confirmationVisible: false})}
													 onConfirm={() => this.changeToConfirmed()}
													 surveyWithEmail={this.props.contact.map(
														 c => c.hasEmailAddress()).getOrElse(false)
													 && this.state.surveyAppointment}
													 surveyWithMobile={this.props.contact.map(
														 c => c.isOneOfPhoneNumbersMobile()).getOrElse(false)
													 && this.state.surveyAppointment}/>}
			</tr>
		)
	}

	/**
	 * Get assigned sales engineers display name.
	 * @returns {string} sales engineer's first name + first letter of last name e.g. John D.
	 */
	displayAssignedSalesEngineers(): JSX.Element[] {
		return this.props.salesEngineers.getOrElse([]).map((se, index) => {
			return (
				<span key={index} className="d-block">
					{se.getDisplayName(true)}
				</span>
			)
		});
	}

	/**
	 * Checks if sales engineer has profile URL.
	 * @returns {boolean}
	 */
	salesEngineerHasProfileUrl(user: User) {
		return user.data.profileUrl.isDefined;
	}

	/**
	 * Render 'Send SMS' button.
	 */
	renderSMSButton() {
		if (this.props.appointment instanceof Appointment && this.props.salesEngineers.getOrElse([]).length == 1) {
			const se = this.props.salesEngineers.getOrElse([])[0];
			if (this.props.contact.map(c => c.isOneOfPhoneNumbersMobile()).getOrElse(false)) {
				if (!this.salesEngineerHasProfileUrl(se)) {
					return "No profile URL available";
				}
				return (
					<ButtonSecondary label="Send SMS with profile"
									 disabled={this.props.appointment.dateTime.isBefore(moment())}
									 onClick={this.sendSms}/>
				);
			}
			else {
				return "No SMS device available";
			}
		}
		return null;
	}

	sendSms() {
		if (this.props.appointment instanceof Appointment) {
			this.props.salesEngineers.getOrElse([]).map(se => {
				const seData = {salesEngineerId: se.id};
				this.props.sendLeadAppointmentSalesEngineerLinkSMS(this.props.appointment as Appointment, seData);
			});
		}
	}

	onChange(data: Option<AppointmentStatus>) {
		data.map(status => {
			if (status.value != this.props.appointment.status.value) {
				if (status.value == AppointmentStatusEnum.Confirmed
					&& ((this.props.contact.map(c => c.isOneOfPhoneNumbersMobile()).getOrElse(false))
						|| (this.props.contact.map(c => c.hasEmailAddress()).getOrElse(false) && this.state.surveyAppointment))) {
					this.setState({confirmationVisible: true});
				}
				else {
					this.props.appointment instanceof Appointment &&
					this.props.onAppointmentStatusChange(this.props.appointment.copy({status}))
				}
			}
		})
	}

	changeToConfirmed() {
		this.setState({confirmationVisible: false}, () => this.props.onAppointmentStatusChange(
			(this.props.appointment as Appointment).copy(
				{status: AppointmentStatus.fromString(AppointmentStatusEnum.Confirmed)})))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		sendLeadAppointmentSalesEngineerLinkSMS: (appointment: Appointment, seData: SalesEngineerApiDto) => dispatch(
			sendLeadAppointmentSalesEngineerLinkSMS(
				appointment,
				seData,
				() => Toast.success("SMS sent", "Confirmation SMS send"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Confirmation SMS send error"))
		)
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const [lastConfirmationSmsSentEvent] = state.lead.events.getOrElse([]).filter(e =>
		e instanceof LeadSmsSentEvent &&
		e.data.subtype === SmsEventSubtypeEnum.CustomerReminderSms &&
		(e.data as LeadAppointmentSmsSentEventData).appointmentId.getOrElse("") === props.appointment.id
	).sort((a, b) => a.creationDate.isBefore(b.creationDate) ? 1 : -1);

	const lastSent = isNullOrUndefined(lastConfirmationSmsSentEvent) ? none :
		option(moment(lastConfirmationSmsSentEvent.creationDate));

	if (props.appointment instanceof Appointment) {
		return props.appointment.leadId.map(leadId => {
			const lead = getLeadByIdOrRefNo(leadId, state);
			const se = (props.appointment as Appointment).assigneeId.flatMap(getUser);
			return {
				salesEngineers: se.isDefined ? option([se.get]) : none,
				contact: lead.flatMap(l => getIndividualContact(l.data.principalContactId, state)),
				lastSent
			}
		}).getOrElse({
			salesEngineers: none,
			contact: getIndividualContact(props.leadFormContactId.orNull, state),
			lastSent: isNullOrUndefined(lastConfirmationSmsSentEvent) ? none :
				option(moment(lastConfirmationSmsSentEvent.creationDate))
		})
	}
	else {
		return props.appointment.jobId.map(jobId => {
			const job = getJobByIdOrRefNumber(jobId, state);
			return {
				salesEngineers: state.user.users.map(
					a => a.filter(u => u.isSalesEngineer())
						.filter(user => (props.appointment as JobAppointment).assignees.indexOf(user.id) > -1)),
				contact: job.flatMap(j => getIndividualContact(j.data.principalContactId, state)),
				lastSent
			}
		}).getOrElse({
			salesEngineers: none,
			contact: none,
			lastSent
		})
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentRow);